<div class="container-lg my-lg-4 main">
  <div class="py-5">
    <div class="row justify-content-center">
      <div class="success-box py-5">
        <div class="text-center" [hidden]="tokenExpired">
          <div class="py-5">
            <div class="text-center " > If you would like to request a refund for {{ email }}, press the button link below.</div>
          </div>
          <div class="py-5" [hidden]="refundDone">
            <div class="btn-sm btn-link" (click)="requestRefund(email)">Refund</div>
          </div>
          <div class="py-5" [hidden]="!refundDone">
            <div class="text-center">Refund done, you will receive a response within 72 hours.</div>
          </div>
        </div>
        <div class="text-center" [hidden]="!tokenExpired">
          <div class="text-center">You need to be logged in to request a refund.</div>
        </div>
      </div>
    </div>
  </div>
</div>
